import React from 'react';
import { services } from '../../data/services';
import { ServiceCard } from '../services/ServiceCard';
import { ButtonLink } from '../ui/ButtonLink';
import { SectionHeading } from '../ui/SectionHeading';
export function HomeServices() {
  const [featured, ...rest] = services;
  return <section className="bg-porcelain py-24 lg:py-32" data-id="element-271" data-mp="1rctvgpin7z4q">
      <div className="mx-auto max-w-7xl px-6 lg:px-10" data-id="element-272" data-mp="1rbiiq077zh1h">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between" data-id="element-273" data-mp="1co73nobtxewm">
          <SectionHeading label="Core services" title="Executive search shaped around what each appointment demands" intro="Eight services covering the full arc of senior leadership — from a single critical appointment to long-term succession readiness." data-id="element-274" data-mp="1hfp8wokvy1ne" />
          <ButtonLink to="/expertise" variant="outline" arrow className="self-start lg:self-auto" data-id="element-275" data-mp="tpbbsjng1cly">
            View all expertise
          </ButtonLink>
        </div>
        <div className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-276" data-mp="yqingtspivxw">
          <ServiceCard service={featured} featured data-id="element-277" data-mp="3vg18i12u88ft" />
          {rest.map(service => <ServiceCard key={service.slug} service={service} data-id="element-278" data-mp="3qi9f12mjoe9i" />)}
        </div>
      </div>
    </section>;
}